<app-card [title]="'service.settings.sidebar.risk-type'" titleSize="large" height="initial">
    <ng-template #content>
        <div [formGroup]="form" class="grid-1col input-grid-gaps">
            <div formArrayName="riskTypes">
                @for (types of riskTypesArray.controls; track $index; let i = $index) {
                    <div class="flex gap-small pt-2">
                        <input pInputText [formControlName]="i"/>
                        <app-delete-button
                            [hideLabel]="true"
                            [confirmationType]="'none'"
                            (clickEvent)="removeRiskType(i)"
                        ></app-delete-button>
                    </div>
                }
            </div>
            <app-button icon="pi-plus" (clickEvent)="addRiskType()"></app-button>
        </div>
    </ng-template>
    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="save()" (secondaryClickEvent)="reset()"></app-action-buttons>
    </ng-template>
</app-card>
